import React from "react";
import { Routes, Route } from "react-router-dom";
import AfterQuiz1 from "./1";
import AfterQuiz2 from "./2";
import AfterQuiz3 from "./3";
import AfterQuiz4 from "./4";
import AfterQuiz5 from "./5";

const AfterQuizRouter = () => {
  return (
    <div>
      <Routes>
        <Route
          path="1"
          element={<AfterQuiz1 />}
        />
        <Route
          path="2"
          element={<AfterQuiz2 />}
        />
        <Route
          path="3"
          element={<AfterQuiz3 />}
        />
        <Route
          path="4"
          element={<AfterQuiz4 />}
        />
        <Route
          path="5"
          element={<AfterQuiz5 />}
        />
        <Route
          path="*"
          element={<AfterQuiz1 />}
        />
      </Routes>
    </div>
  );
};

export default AfterQuizRouter;
